var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "inlineOption",
      class: _vm.classes,
      attrs: {
        tabindex: _vm.tabIndex,
        role: _vm.optionRole,
        "aria-checked": _vm.ariaChecked,
        "aria-labelledby": _vm.optionLabelId,
      },
      on: {
        click: _vm.onClick,
        mouseover: _vm.onMouseOver,
        mouseleave: _vm.onMouseLeave,
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          return _vm.onSpacePressed.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "trbo-a-inline-option__wrapper" }, [
        _vm.option.imageUrl
          ? _c("img", {
              staticClass: "trbo-a-inline-option__image",
              attrs: { src: _vm.option.imageUrl, alt: "" },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "trbo-a-inline-option__title-actions" }, [
          _c("div", { staticClass: "trbo-a-inline-option__title" }, [
            _c(
              "div",
              {
                staticClass: "trbo-a-inline-option__title__content",
                attrs: { id: _vm.optionLabelId },
              },
              [_vm._v("\n          " + _vm._s(_vm.option.title) + "\n        ")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "trbo-a-inline-option__actions" }, [
            _vm.hasInfoText
              ? _c(
                  "div",
                  {
                    staticClass: "trbo-a-inline-option__info-icon",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("info-icon", {
                      attrs: {
                        role: "tooltip",
                        tabindex: "0",
                        "main-icon": _vm.infoIcon,
                        "is-opened": _vm.isOpened,
                        "aria-labelledby": _vm.infoId,
                      },
                      on: {
                        click: _vm.onToggleIsOpened,
                        "esc-pressed": _vm.closeToggle,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isMultiple
              ? _c(
                  "div",
                  { staticClass: "trbo-a-inline-option__check" },
                  [
                    _c("checkbox", {
                      attrs: {
                        "is-hovered": _vm.isHovered,
                        "is-checked": _vm.isSelected,
                        "is-disabled": _vm.isDisabled,
                        "aria-labelledby": _vm.optionLabelId,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.hasInfoText
        ? _c(
            "animation-height",
            {
              key: _vm.option.uuid,
              attrs: { "is-visible": _vm.isOpened, "use-opacity": "" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "trbo-a-inline-option__info-container",
                  attrs: { id: _vm.infoId, "aria-hidden": !_vm.isOpened },
                },
                [
                  _c(
                    "div",
                    { staticClass: "trbo-a-inline-option__info-text" },
                    [
                      _c("info-text", {
                        attrs: {
                          "is-opened": _vm.isOpened,
                          title: _vm.infoTitle,
                          description: _vm.infoDescription,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }